<router-outlet>

</router-outlet>
<div style="width: max-content">
    <!-- @if(testingTabeledOption.rawTableData){
    <app-tabled-option [columnMetaData]="testingTabeledOption.columnMetaData" [columns]="testingTabeledOption.columns"
        [rawTableData]="testingTabeledOption.rawTableData" (selectedRow)="processSelection($event)"
        [tableHeaderMetaData]="testingTabeledOption.headerFilter">

    </app-tabled-option>} -->
</div>